"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ptrace = void 0;
var IRNative_1 = require("../../../IR/IRNodes/IRNative/index.js");
var Term_1 = require("../../Term/index.js");
var type_system_1 = require("../../type_system/index.js");
var addApplications_1 = require("./addApplications.js");
function ptrace(returnT) {
    return (0, addApplications_1.addApplications)(new Term_1.Term((0, type_system_1.fn)([type_system_1.str, returnT], returnT), function (_dbn) { return IRNative_1.IRNative.trace; }));
}
exports.ptrace = ptrace;
